import type { BusinessItem } from "./types";

export function normalizeOrder(items: BusinessItem[]) {
  return items.map((it, idx) => ({ ...it, order: idx }));
}

export function sortByOrder(items: BusinessItem[]) {
  return [...items].sort((a, b) => a.order - b.order);
}
